/**
 * @fileoverview Input component for text entry.
 * Standard HTML input with consistent styling.
 * @module components/ui/input
 */

import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Text input component with standardized styling.
 * Supports all standard HTML input types.
 * @param props - HTML input props
 * @param ref - Forwarded ref to the input element
 */
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
